import React, { useContext } from 'react';
import { ThemeContext } from '../theme';
import ProfileDP from './ProfileDP';
import Button from './Button';

export default function ProfileCard({ variant = 'adult', src, name, onButton, scale = 1 }) {
  const theme = useContext(ThemeContext);
  const s = (n) => Math.round(n * scale);
  const isNew = variant === 'new';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: `${s(32)}px ${s(40)}px`,
        backgroundColor: theme.cardBg100,
        borderRadius: s(20),
        width: s(280),
        height: s(360),
        flexShrink: 0,
        boxSizing: 'border-box',
      }}
    >
      {/* Avatar zone */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          overflow: 'visible',
        }}
      >
        {isNew ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: s(16) }}>
            <div style={{ width: s(120), height: s(120), display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width={s(52)} height={s(52)} viewBox="0 0 52 52" fill="none">
                <path d="M26 8v36M8 26h36" stroke={theme.text100} strokeWidth="4" strokeLinecap="round" />
              </svg>
            </div>
            <span
              className="font-satoshi font-bold"
              style={{ fontSize: s(18), lineHeight: `${s(24)}px`, color: theme.text100, whiteSpace: 'nowrap' }}
            >
              {name}
            </span>
          </div>
        ) : (
          <ProfileDP variant={variant} src={src} name={name} scale={scale} />
        )}
      </div>

      {/* Action button */}
      <Button
        variant="secondary"
        onClick={onButton}
        scale={scale}
        style={{ width: '100%', flexShrink: 0 }}
      >
        {isNew ? 'Create' : 'Edit Profile'}
      </Button>
    </div>
  );
}
